import { type NamedExoticComponent, type ReactElement, memo } from "react"

import map from "lodash-es/map"
import { NavLink } from "react-router-dom"

import { propsAreEqual } from "@/3514/utils"

import classes from "./coach.header-tabs.styles"
import type { TCoachHeaderTab } from "./coach.header-tabs.types"

const CoachHeaderTabs: NamedExoticComponent<{ tabs: TCoachHeaderTab[] }> = memo(
    ({ tabs }: { tabs: TCoachHeaderTab[] }): ReactElement => (
        <nav className={classes.container()}>
            {map<TCoachHeaderTab, ReactElement>(
                tabs,
                (tab: TCoachHeaderTab): ReactElement => (
                    <div key={`c-hd-tab-${tab.label}`} className={classes.item({ isCurrent: tab.isCurrent })}>
                        <NavLink
                            className={classes.link({ isCurrent: tab.isCurrent })}
                            onFocus={tab.onHover}
                            onMouseOver={tab.onHover}
                            to={tab.href}
                        >
                            {tab.label}
                        </NavLink>
                    </div>
                )
            )}
        </nav>
    ),
    propsAreEqual
)

CoachHeaderTabs.displayName = "CoachHeaderTabs"

export { CoachHeaderTabs }
